$(document).ready(function () {
    var active_product_id = parseInt(window.active_product_id) || -1;
    if (active_product_id === -1) return;
    var yotpo_reviews_id=-1;
    if(window.yotpo_reviews_id)
    {
        yotpo_reviews_id=window.yotpo_reviews_id;
    }
    var data = {
        shopUrl: window.shopUrl,
        currentUrl: window.location.href,
        product_id: active_product_id,
        yotpo_reviews_id: yotpo_reviews_id
    };

    // Generates a token for API authentication
    function generateToken() {
        var token = new Date().getTime().toString();
        return btoa(btoa(btoa(token))).split('').reverse().join('').replace(/=/g, '');
    }

    // Updates the star rating for a given selector
    function updateStarRating(selector, average_score) {
        var rating = $(selector).find('input[name^="rating-product"]');
        var roundedScore = Math.ceil(average_score);
        if(roundedScore==average_score)
        {
            rating.filter('[value="' + roundedScore + '"]').prop('checked', true).attr('checked', true);
        }
        else
        {
            rating.filter('[value="' + roundedScore + '"]').prop('checked', true).attr('checked', true);
            rating.filter('[value="' + roundedScore + '"]').next('label').addClass('half-star');
        }
    }

    // Fetches and displays product reviews
    function fetchReviews() {
        $.ajax({
            url: window.BackendUrl + '/product/review/get',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + generateToken()
            },
            data: JSON.stringify(data),
            success: function (result) {
                $('#star-review-inline, #star-review-box').removeClass('d-none');

                if (result && result.success && result.body && result.body.reviews) {
                    var average_score = result.body.reviews.average_score || 0;
                    var total_reviews = result.body.reviews.total_reviews || 0;

                    updateStarRating('#star-review-inline', average_score);
                    updateStarRating('#star-review-box', average_score);
                    updateStarRating('#star-review-popup', average_score);

                    $('#star-review-inline .totalReview .total').text(total_reviews);
                    $('#star-review-box .totalReview .total').text(average_score);
                    $('#star-review-popup .totalReview .total').text(average_score);

                    $('.star-review-buyer p').text(function (_, text) {
                        return text.replace('{{total}}', '');
                    });
                    $('.total-buyers').text(function (_, text) {
                        return text.replace('{{total}}', '');
                    });

                    $('.star-review-buyer, .total-buyers').removeClass('d-none');
                } else {
                    console.error('Error getting review', result);
                }
            },
            error: function (error) {
                console.error('Error getting review:', error);
                $('#star-review-inline, #star-review-box').removeClass('d-none');
            }
        });
    }

    fetchReviews();

    // Initializes the sidebar functionality
    function initializeSidebar() {
        var $openReviewsBtn = $('.open-reviews');
        var $reviewsSidebar = $('#reviewsSidebar');
        var $sidebarBackdrop = $('#sidebarBackdropReview');

        // Opens the sidebar
        function openSidebar(e) {
            e.preventDefault();
            if ($sidebarBackdrop.length > 0 && $reviewsSidebar.length > 0) {
                $reviewsSidebar.addClass('show');
                $sidebarBackdrop.addClass('show');
                $('.continue-shopping').addClass('active');
                $('body').css('overflow', 'hidden');
                getDetailReviews(active_product_id);
            }
        }

        // Closes the sidebar
        function closeSidebar() {
            $reviewsSidebar.removeClass('show');
            $sidebarBackdrop.removeClass('show');
            $('.continue-shopping').removeClass('active');
            $('body').css('overflow', '');
        }

        $openReviewsBtn.on('click', openSidebar);
        $reviewsSidebar.find('.btn-close').on('click', closeSidebar);
        $sidebarBackdrop.on('click', closeSidebar);
    }

    initializeSidebar();

    var page = 1;
    var stopRequest = false;
    var loading = false;
    var reviewContainer = $('.reviews-details');
    var reviewLoading = $('.reviews-loading');

    // Loads initial reviews and sets up infinite scroll
    function getDetailReviews(productId) {
        loadReviews(productId);
        $('.offcanvas-body').on('scroll', function () {
            if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight - 100) {
                loadReviews();
            }
        });
    }

    // Calculates time ago from a given date
    function timeAgo(date) {
        var seconds = Math.floor((new Date() - date) / 1000);
        var interval = seconds / 31536000;

        if (interval > 1) {
            return Math.floor(interval) + " years ago";
        }
        interval = seconds / 2592000;
        if (interval > 1) {
            return Math.floor(interval) + " months ago";
        }
        interval = seconds / 86400;
        if (interval > 1) {
            return Math.floor(interval) + " days ago";
        }
        interval = seconds / 3600;
        if (interval > 1) {
            return Math.floor(interval) + " hours ago";
        }
        interval = seconds / 60;
        if (interval > 1) {
            return Math.floor(interval) + " minutes ago";
        }
        return Math.floor(seconds) + " seconds ago";
    }

    // Creates HTML for a single review
    function createReviewElement(review) {
        var stars = Array(review.score + 1).join('★') + Array(6 - review.score).join('☆');
        var imageUrl = review.image_url && review.image_url.length > 0 ? review.image_url : '';
        var created_at = review.created_at ? timeAgo(new Date(review.created_at)) : '';

        var title = review.title ? '<p class="review-title">' + review.title + '</p>' : '';
        var content = review.content ? '<p class="review-content">' + review.content + '</p>' : '';
        var author = review.user.display_name ? '<p class="review-author"><b>' + review.user.display_name + '</b> - <span class="text-gray-400">' + created_at + '</span></p>' : '';
        return [
            '<div class="row w-100 mb-5">',
                '<div class="col-4">',
                    imageUrl ? '<img src="' + imageUrl + '" alt="Review Image" class="img-thumbnail border-0 w-100">' : '',
                '</div>',
                '<div class="col-8">',
                    '<div class="review-rating">' + stars + '</div>',
                    title,
                    content,
                    author,
                '</div>',
            '</div>'
        ].join('');
    }

    // Loads reviews from the server
    function loadReviews(productId) {
        if (stopRequest || loading) return;
        loading = true;
        reviewLoading.removeClass('d-none');

        var data = {
            shopUrl: window.shopUrl,
            currentUrl: window.location.href,
            product_id: active_product_id,
            page: page
        };

        $.ajax({
            url: window.BackendUrl + '/product/review/details',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + generateToken()
            },
            data: JSON.stringify(data),
            success: function (response) {
                if (response && response.success && response.body && response.body.reviews) {
                    if(page==1)
                    {
                        reviewContainer.empty();
                    }
                    response.body.reviews.forEach(function (review) {
                        reviewContainer.append(createReviewElement(review));
                    });
                    page++;
                    if (response.body.reviews.length === 0) {
                        stopRequest = true;
                    }
                }
                loading = false;
                reviewLoading.addClass('d-none');
            },
            error: function (error) {
                console.error('Error fetching reviews:', error);
                loading = false;
                reviewLoading.addClass('d-none');
            }
        });
    }
});